
import './WhatsappButton.css';
import whatsappLogo from "../assets/images/WhatsAppicon.webp";

const WhatsAppButton = () => {
  const phoneNumber = "918178909878"; // Your WhatsApp number
  const message = "Hello Wicuna Technologies, I would like to know more about your services.";

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-button"
      aria-label="Chat with us on WhatsApp"
    >
      <img src={whatsappLogo} alt='Whatsapp Wicuna Tech' />
    </a>
  );
};

export default WhatsAppButton;